// Options for the Scholarship module select fields.
// `id` is the value persisted to the backend (Country / Currency are strings),
// `name` is what the user sees.

export const COUNTRY_OPTIONS = [
  "Afghanistan",
  "Australia",
  "Bangladesh",
  "Canada",
  "China",
  "Egypt",
  "France",
  "Germany",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Italy",
  "Jordan",
  "Kenya",
  "Malaysia",
  "Morocco",
  "Nigeria",
  "Pakistan",
  "Palestine",
  "Qatar",
  "Saudi Arabia",
  "Somalia",
  "South Africa",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Syria",
  "Turkey",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Yemen",
].map(country => ({ id: country, name: country }))

export const CURRENCY_OPTIONS = [
  { id: "PKR", name: "PKR - Pakistani Rupee" },
  { id: "INR", name: "INR - Indian Rupee" },
  { id: "CAD", name: "CAD - Canadian Dollar" },
  { id: "USD", name: "USD - US Dollar" },
]
